import { render, staticRenderFns } from "./StockPriceInfos.vue?vue&type=template&id=72bf34b5&scoped=true&"
import script from "./StockPriceInfos.vue?vue&type=script&lang=js&"
export * from "./StockPriceInfos.vue?vue&type=script&lang=js&"
import style0 from "./StockPriceInfos.vue?vue&type=style&index=0&id=72bf34b5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bf34b5",
  null
  
)

export default component.exports